import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import { Analytics } from "@vercel/analytics/react";
import { Navigation } from "./components/Navigation";
import { Footer } from "./components/Footer";
import { ScrollToTop } from "./components/ScrollToTop";
import { usePageTitle } from "./hooks/usePageTitle";
import { Home } from "./pages/Home";
import { Services } from "./pages/Services";
import { Portfolio } from "./pages/Portfolio";
import { About } from "./pages/About";
import { Contact } from "./pages/Contact";
import { Pods } from "./pages/Pods";
import { ProjectDetail } from "./pages/ProjectDetail";
import "./App.css";

const PageWrapper = ({ children }: { children: React.ReactNode }) => {
  const location = useLocation();
  usePageTitle();

  return (
    <>
      {/* Route progress indicator */}
      <div
        key={`${location.pathname}-indicator`}
        className="fixed top-0 left-0 h-1 bg-gradient-to-r from-brand-primary to-brand-tertiary z-50"
        style={{
          animation: "progressBar 0.3s ease-out",
          width: "100%",
        }}
      />
      <div
        key={location.pathname}
        className="animate-fadeIn"
        style={{
          animation: "fadeIn 0.3s ease-in-out",
          minHeight: "calc(100vh - 200px)",
        }}
      >
        {children}
      </div>
    </>
  );
};

function App() {
  return (
    <Router>
      <div className="min-h-screen bg-[#f7f7f7]">
        <ScrollToTop />
        <Navigation />
        <Routes>
          <Route
            path="/"
            element={
              <PageWrapper>
                <Home />
              </PageWrapper>
            }
          />
          <Route
            path="/services"
            element={
              <PageWrapper>
                <Services />
              </PageWrapper>
            }
          />
          <Route
            path="/portfolio"
            element={
              <PageWrapper>
                <Portfolio />
              </PageWrapper>
            }
          />
          <Route
            path="/pods"
            element={
              <PageWrapper>
                <Pods />
              </PageWrapper>
            }
          />
          <Route
            path="/about"
            element={
              <PageWrapper>
                <About />
              </PageWrapper>
            }
          />
          <Route
            path="/contact"
            element={
              <PageWrapper>
                <Contact />
              </PageWrapper>
            }
          />
          <Route
            path="/projects/:id"
            element={
              <PageWrapper>
                <ProjectDetail />
              </PageWrapper>
            }
          />
        </Routes>
        <Footer />
      </div>
      <Analytics />
    </Router>
  );
}

export default App;
